import styled from 'styled-components'

export const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.6);
  backdrop-filter: blur(4px);
  z-index: 1000;
`

export const ModalContainer = styled.div`
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: #ffffff;
  border-radius: 16px;
  width: 90%;
  max-width: 520px;
  max-height: 90vh;
  overflow: hidden;
  box-shadow: 0px 20px 60px rgba(0, 0, 0, 0.3);
  z-index: 1001;
  display: flex;
  flex-direction: column;

  @media (max-width: 768px) {
    width: 95%;
    max-height: 85vh;
    border-radius: 12px;
  }
`

export const ModalHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 24px;
  border-bottom: none;
  background: linear-gradient(135deg, #a31e66 0%, #ff3f72 100%);
  border-radius: 16px 16px 0 0;
`

export const ModalTitle = styled.h2`
  font-size: 18px;
  font-weight: 600;
  color: #ffffff;
  margin: 0;
  letter-spacing: -0.02em;
`

export const CloseButton = styled.button`
  background: rgba(255, 255, 255, 0.2);
  border: none;
  font-size: 24px;
  color: #ffffff;
  cursor: pointer;
  padding: 0;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  transition: all 0.2s;

  &:hover {
    background: rgba(255, 255, 255, 0.3);
    color: #ffffff;
  }
`

export const ModalContent = styled.div`
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  overflow-y: auto;
  max-height: calc(90vh - 80px);
`

export const InstructionsBox = styled.div`
  padding: 16px;
  background: #fff5ec;
  border: 1px solid #ffd4a3;
  border-radius: 12px;
  display: flex;
  align-items: flex-start;
  gap: 12px;
`

export const InstructionsIcon = styled.div`
  width: 20px;
  height: 20px;
  flex-shrink: 0;
  margin-top: 2px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #ff5100;
  font-size: 18px;
`

export const InstructionsContent = styled.div`
  flex: 1;
`

export const InstructionsTitle = styled.p`
  font-size: 14px;
  color: #2c2b43;
  font-weight: 600;
  margin: 0 0 6px 0;
`

export const InstructionsText = styled.p`
  font-size: 13px;
  color: #667085;
  margin: 0;
  line-height: 1.6;
`

export const PermissionsCard = styled.div`
  background: #f9fafb;
  border-radius: 12px;
  padding: 16px;
  border: 1px solid #e5e7eb;
`

export const PermissionsTitle = styled.h3`
  font-size: 15px;
  font-weight: 600;
  color: #2c2b43;
  margin: 0 0 16px 0;
  display: flex;
  align-items: center;
  gap: 8px;
`

export const PermissionsList = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 12px;
`

export const PermissionItem = styled.div`
  width: calc(50% - 6px);
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px;
  background: #ffffff;
  border-radius: 8px;
  border: 1px solid #e5e7eb;
`

export const PermissionInfo = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  flex: 1;
`

export const PermissionIcon = styled.div<{ status: string | null }>`
  width: 40px;
  height: 40px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${({ status }) =>
    status === 'granted'
      ? '#ecfdf3'
      : status === 'denied'
        ? '#fef2f2'
        : '#fff5ec'};
  flex-shrink: 0;

  svg {
    width: 20px;
    height: 20px;
    color: ${({ status }) =>
      status === 'granted'
        ? '#1FBA5D'
        : status === 'denied'
          ? '#EF3840'
          : '#FFA500'};
  }
`

export const PermissionText = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
`

export const PermissionLabel = styled.span`
  font-size: 14px;
  font-weight: 500;
  color: #2c2b43;
`

export const StatusText = styled.span<{ status: string | null }>`
  font-size: 13px;
  font-weight: 500;
  color: ${({ status }) =>
    status === 'granted'
      ? '#1FBA5D'
      : status === 'denied'
        ? '#EF3840'
        : '#FFA500'};
`

export const TipsSection = styled.div<{ hasDeniedPermissions: boolean }>`
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-bottom: ${({ hasDeniedPermissions }) =>
    hasDeniedPermissions ? '100px' : '50px'};
`

export const TipItem = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 12px;
  background: #f9fafb;
  border-radius: 10px;
`

export const TipIcon = styled.div`
  width: 32px;
  height: 32px;
  border-radius: 8px;
  background: #f0f2f8;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  color: #a31e66;
  font-size: 16px;
`

export const TipText = styled.p`
  font-size: 13px;
  color: #667085;
  margin: 0;
  line-height: 1.6;
  padding-top: 4px;

  strong {
    color: #2c2b43;
    font-weight: 500;
  }
`

export const CameraNetworkContainer = styled.div`
  display: flex;
  gap: 12px;
  width: 100%;

  @media (max-width: 768px) {
    flex-direction: column;
  }
`

export const CameraPreview = styled.div`
  flex: 1;
  min-width: 0;
  background: #000;
  border-radius: 12px;
  overflow: hidden;
  position: relative;
  aspect-ratio: 16 / 9;
  display: flex;
  align-items: center;
  justify-content: center;
`

export const CameraVideo = styled.video`
  width: 100%;
  height: 100%;
  object-fit: cover;
`

export const CameraPlaceholder = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 12px;
  width: 100%;
  height: 100%;
  color: #667085;
`

export const CameraPlaceholderIcon = styled.div`
  width: 48px;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #667085;

  svg {
    width: 48px;
    height: 48px;
  }
`

export const CameraPlaceholderText = styled.span`
  font-size: 14px;
  color: #667085;
  text-align: center;
`

export const NetworkCard = styled.div`
  flex: 1;
  min-width: 0;
  background: #f9fafb;
  border-radius: 12px;
  padding: 16px;
  border: 1px solid #e5e7eb;
  display: flex;
  flex-direction: column;

  @media (max-width: 768px) {
    width: 100%;
  }
`

export const NetworkTitle = styled.h3`
  font-size: 15px;
  font-weight: 600;
  color: #2c2b43;
  margin: 0 0 16px 0;
`

export const NetworkStatus = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`

export const NetworkInfo = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`

export const NetworkIcon = styled.div<{ status: string }>`
  width: 40px;
  height: 40px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${({ status }) =>
    status === 'excellent'
      ? '#ecfdf3'
      : status === 'good'
        ? '#eff6ff'
        : status === 'poor'
          ? '#fff5ec'
          : '#fef2f2'};
  flex-shrink: 0;
  color: ${({ status }) =>
    status === 'excellent'
      ? '#1FBA5D'
      : status === 'good'
        ? '#3B82F6'
        : status === 'poor'
          ? '#F59E0B'
          : '#EF3840'};

  svg,
  & > * {
    width: 24px;
    height: 24px;
    color: ${({ status }) =>
      status === 'excellent'
        ? '#1FBA5D'
        : status === 'good'
          ? '#3b82f6'
          : status === 'poor'
            ? '#FFA500'
            : '#EF3840'};
  }
`

export const NetworkText = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
  flex: 1;
`

export const NetworkLabel = styled.span`
  font-size: 14px;
  font-weight: 500;
  color: #2c2b43;
`

export const NetworkStatusText = styled.span<{ status: string }>`
  font-size: 13px;
  font-weight: 500;
  color: ${({ status }) =>
    status === 'excellent'
      ? '#1FBA5D'
      : status === 'good'
        ? '#3b82f6'
        : status === 'poor'
          ? '#FFA500'
          : '#EF3840'};
`

export const NetworkDetails = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding-left: 52px;
  font-size: 12px;
  color: #667085;
`

export const NetworkDetailItem = styled.div`
  display: flex;
  gap: 4px;

  strong {
    color: #2c2b43;
    font-weight: 500;
    padding-top: 2px;
  }
`

export const NetworkWarning = styled.div`
  padding: 12px;
  background: #fff5ec;
  border: 1px solid #ffd4a3;
  border-radius: 8px;
  display: flex;
  align-items: flex-start;
  gap: 10px;
`

export const WarningIcon = styled.span`
  font-size: 18px;
  flex-shrink: 0;
  margin-top: 2px;
`

export const WarningText = styled.p`
  font-size: 12px;
  color: #667085;
  margin: 0;
  line-height: 1.5;
  flex: 1;

  strong {
    color: #2c2b43;
    font-weight: 600;
  }
`

export const ButtonsContainer = styled.div`
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 8px 16px;
`
